import * as R from 'ramda';
import { CategoryItem } from 'types/api/envScales/AssessmentScore';

export function containsNotApplicable(items: CategoryItem[]) {
  return R.any(item => !item.required, items);
}
